import { selectFromProjectDto } from '../../models';

export default selectFromProjectDto()
  .id
  .name
  .startDate
  .source
  .createdOn
  .organizationId
  .isSynced
  .toString();
